import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Text from '@zg-rentals/multibrand-ui/lib/Text';

// Stylesheets
import 'app/shared/components/Graphs/style.scss';

const propTypes = {
    message: PropTypes.string,
};

const defaultProps = {
    message: 'No data available.',
};

const GraphEmptyMessage = ({ message }) => (
    <div className="Graph-empty-message">
        <Text type="h4">{message}</Text>
    </div>
);

GraphEmptyMessage.propTypes = propTypes;
GraphEmptyMessage.defaultProps = defaultProps;

export default GraphEmptyMessage;
